import './_navigation-desktop.scss';
import component from './navigation-desktop';

export default component;
